import React, { useEffect, useState } from 'react'
import { api } from '../../../app/Api/ApiSlice'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Loader from '../../../components/Loader'
import AdOrgPost from '../../../components/AdOrgPost'
import InfiniteScroll from 'react-infinite-scroll-component'

const PostsAds = () => {
  const [posts, setPosts] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [hasMore, setHasMore] = useState(true)

  const { organization } = useParams()

  useEffect(() => {
    const getOrgPosts = async () => {
      try {
        setIsLoading(true)
        const response = await api.get(`/${organization}/manage/promotions/posts?page=${page}`)
        console.log(response.data)

        const newPosts = response?.data.posts || []

        if (newPosts.length === 0) {
          setHasMore(false)
          setIsLoading(false)
          return
        }

        setPosts(prev => [...prev, ...newPosts])
        setIsLoading(false)
      } catch (error) {
        setIsLoading(false)
        setHasMore(false)
        toast.error(error?.response?.data?.message || 'Failed to load posts')
      }
    }

    getOrgPosts()
  }, [organization, page])

  return (
    <div>
      <h4>Posts</h4>

      <div className="orgposts-ad-content">
        <InfiniteScroll
          dataLength={posts.length}
          next={() => setPage(prev => prev + 1)}
          hasMore={hasMore}
          loader={<Loader />}
        >
          {posts.map(post => (
            <div key={post._id} className="">
              <AdOrgPost postAd={post} />
            </div>
          ))}
        </InfiniteScroll>

        {/* {!isLoading && posts.length === 0 && (
          <p>No posts available.</p>
        )} */}
      </div>
    </div>
  )
}

export default PostsAds
